module.exports = __webpack_public_path__ + "static/img/coupon-bg-top.39be5ef.png";